import React from 'react';
// styles
import styled from 'styled-components';

const CopyIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Copy"
    className={className}
    role="img"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2847_44628)">
      <path
        d="M10.6668 1.16667H2.66683C1.9335 1.16667 1.3335 1.76667 1.3335 2.5V11.8333H2.66683V2.5H10.6668V1.16667ZM12.6668 3.83334H5.3335C4.60016 3.83334 4.00016 4.43334 4.00016 5.16667V14.5C4.00016 15.2333 4.60016 15.8333 5.3335 15.8333H12.6668C13.4002 15.8333 14.0002 15.2333 14.0002 14.5V5.16667C14.0002 4.43334 13.4002 3.83334 12.6668 3.83334ZM12.6668 14.5H5.3335V5.16667H12.6668V14.5Z"
        fill="#263340"
      />
    </g>
    <defs>
      <clipPath id="clip0_2847_44628">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.500004)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default styled(CopyIcon)``;
